import React, { useContext, useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import { Container, Row, Col, Button } from "react-bootstrap";
import Checkbox from "@material-ui/core/Checkbox";
import axios from "axios";
import { API_ENDPOINT } from "../../AppConfig";
import { Redirect } from "react-router";
import Snackbar from "@material-ui/core/Snackbar";
import cookie from "react-cookies";
import { Link } from "react-router-dom";
import { Req } from "../Request/request";
import LoadingBar from "react-top-loading-bar";
import Lottie from "react-lottie";
import animationData from "../../Assets/lottieFiles/addBtn.json";
import socketIOClient from "socket.io-client";
import {
  LoginFormContext,
  userCookieContext,
  userSessionContext,
  userTokenContext,
  LangContext,
} from "../../App";
import String from "../../Assets/Localization/Local";
import enUS from "antd/es/locale/en_US";
import arEG from "antd/es/locale/ar_EG";
export const ConfirmCodeModal = React.createContext();

const Field = (props) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  // console.log('field props==> ', props)

  let passwordRef = useRef(null);
  const { lang } = useContext(LangContext);
  const { openLoginForm, ToggleLoginForm } = useContext(LoginFormContext);

  const [fetchedData, setFetchedData] = React.useState({});
  const { disableButton, setDisableButton } = React.useState(false);

  const [inputsField, setInputsField] = React.useState(props.inputs);
  const [redirect, setredirect] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [error, setErrorSnakbar] = React.useState(null);

  const [loadingImg, setLoadingImg] = useState(false);
  const [imgUrl, setImgUrl] = useState("");

  const [Data, setData] = useState({});
  const [object, setObject] = useState({});
  const [showConfirmMail_modal, setShowConfirmMail_modal] = useState(false);
  const [confirmMailData, setConfirmMailData] = useState("");
  const [ConfirmMailDone, setConfirmMailDone] = useState(false);
  const [loadingBarProgress, setLoadingBarProgress] = useState(0);
  const [loading, setLoading] = useState(false);

  const { userCookie, handleUserCookie } = useContext(userCookieContext);
  const { userSession, handleUserSession } = useContext(userSessionContext);
  const { userToken, handleUserToken } = useContext(userTokenContext);

  const {
    register,
    handleSubmit,
    errors,
    control,
    watch,
    setValue,
    getValues,
    clearError,
    setError,
  } = useForm({
    validationSchema: props.validation,
  });
  // console.log('watch form---> ', watch(),errors)

  useEffect(() => {
    if (
      props.config.EditForm &&
      props.config.EditForm === true &&
      fetchedData !== {}
    ) {
      initialize();
    }
  }, [fetchedData]);

  useEffect(() => {
    if (props.config.EditForm && props.config.EditForm === true) {
      let uri = `${API_ENDPOINT}${props.config.FetchUrl}`;
      let token_cookie = cookie.load("CatchIt_token");
      let token_sessionStorage = sessionStorage.getItem("CatchIt_token");

      let token = `Bearer ${
        token_cookie ? token_cookie : JSON.parse(token_sessionStorage)
      }`;
      // console.log('fetch uri and token ==> ', uri, token)

      axios
        .get(uri, {
          headers: {
            Authorization: token,
            "Accept-Language": lang,
          },
        })
        .then((response) => {
          // console.log('fetch data done--> ', response.data)
          setFetchedData(response.data);
        })
        .catch((error) => {
          setLoading(false);
          // console.log('fetch data error--> ', error.response)
        });
    }
  }, []);

  const initialize = () => {
    // console.log('hello from initialize')

    for (let i = 0; i < props.config.fetchLabels.length; i++) {
      setValue(
        props.config.fetchLabels[i],
        fetchedData[props.config.fetchLabels[i]]
      );
    }
    // console.log('watch form11==> ', watch())
  };

  const add = (value) => {
    setLoadingBarProgress(loadingBarProgress + value);
  };

  const complete = () => {
    setLoadingBarProgress(100);
  };

  const onLoaderFinished = () => {
    setLoadingBarProgress(0);
  };
  const onSubmit = (data,e) => {
    setLoading(true);
    // console.log('dddataa==> ', data, getValues())

    const SubmitData = new FormData();
    const NoramlData = {};

    if (props.config.haveOneImg && props.config.haveOneImg === true) {
      for (let i = 0; i < props.config.submitLabels.length; i++) {
        if (props.config.submitLabels[i] === "listWithValue") {
          for (let j = 0; j < props.config.listWithValue.length; j++) {
            // console.log("values take place ===>", props.config.listWithValue[j], data[props.config.listWithValue[j]].value)
            if (data[props.config.listWithValue[j]] === undefined) {
              setError(props.config.listWithValue[j], "required", "kkkk,,,,");
            } else {
              SubmitData.append(
                props.config.listWithValue[j],
                data[props.config.listWithValue[j]].value
              );
            }
          }
        } else if (props.config.submitLabels[i] === "listWithUri") {
          for (let j = 0; j < props.config.listWithUri.length; j++) {
            SubmitData.append(
              props.config.listWithUri[j],
              data[props.config.listWithUri[j]].id
            );
          }
        } else if (props.config.submitLabels[i] === "StringData") {
          for (let k = 0; k < props.config.StringData.length; k++) {
            SubmitData.append(
              props.config.StringData[k].key1,
              props.config.StringData[k].key2
            );
          }
        } else {
          SubmitData.append(
            props.config.submitLabels[i],
            data[props.config.submitLabels[i]]
          );
        }
      }
    } else {
      // console.log("data ====>", props.config)
      for (let k = 0; k < props.config.submitLabels.length; k++) {
        if (
          data[props.config.submitLabels[k]] &&
          data[props.config.submitLabels[k]] !== ""
        ) {
          NoramlData[props.config.submitLabels[k]] =
            data[props.config.submitLabels[k]];
        }
      }
    }
    // console.log("Post Req Login :", data, NoramlData)

    if (props.config !== undefined) {
      for (let parts of SubmitData.entries()) {
        // console.log('parts==> ', parts[0], '  +  ', parts[1])
      }
      if (
        props.config.loginFlag !== undefined ||
        props.config.loginFlag === true
      ) {
        AuthPostAxios(props.config.url, data);
      } else if (
        props.config.signUpFlag !== undefined &&
        props.config.signUpFlag === true
      ) {
        SubmitData.append("countryCode", "20");
        SubmitData.append("countryKey", "EG");
        SubmitData.append("name", data.name);
        SubmitData.append("phone", data.phone);
        SubmitData.append("email", data.email);
        SubmitData.append("password", data.password);
        // console.log('data sign up==> ', data)
        for (let parts of SubmitData.entries()) {
          console.log("Sign up parts==> ", parts[0], "  +  ", parts[1], data);
        }
        AuthPostAxios(props.config.url, SubmitData);
      } else {
        if (
          (props.config.haveImages && props.config.haveImages === true) ||
          (props.config.haveOneImg && props.config.haveOneImg === true)
        ) {
          postAxios(props.config.url, SubmitData);
        } else {
          // console.log('send Noraml data=> ', props.config.url, data,NoramlData)
          postAxios(props.config.url, NoramlData,e);
        }
      }
    }
  };

  const AuthPostAxios = (url, data) => {
    // console.log("before Post Req Login :", url,data)
    complete();
    // add(50)
    axios
      .post(`${API_ENDPOINT}${url}`, data, {
        headers: {
          "Accept-Language": lang,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // console.log("Post Req Login :", response.data)
        complete();
        const socket = socketIOClient(
          "https://www.health-book.net:3000/utils",
          {
            query: {
              id: response.data.user.id,
            },
          }
        );
        // console.log("theSocket", socket);
        if (data.rememberMe === true) {
          //save in cookies
          cookie.save("CatchItUser", response.data.user, { path: "/" });
          cookie.save("CatchIt_token", response.data.token, { path: "/" });
          handleUserCookie();
          handleUserToken(response.data.token);
        } else {
          // save in session
          sessionStorage.setItem(
            "CatchItUser",
            JSON.stringify(response.data.user)
          );
          sessionStorage.setItem(
            "CatchIt_token",
            JSON.stringify(response.data.token)
          );
          let getData = JSON.parse(sessionStorage.getItem("CatchItUser"));
          // console.log('session data===> ', getData)
          handleUserSession();
          handleUserToken(response.data.token);
        }

        if (props.config.redirectflag) {
          setredirect(true);
        } else {
          ToggleLoginForm();
        }
      })
      .catch((error) => {
        if (!error.response) {
          setErrorSnakbar("Network Error");
        } else if (error.response.status === 422) {
          for (let i = 0; i < error.response.data.errors.length; i++) {
            setErrorSnakbar(error.response.data.errors[i].msg);
          }
        } else {
          setErrorSnakbar(error.response.data.errors);
        }
        setLoading(false);
        setOpen(true);
      });
  };

  const postAxios = (url, data,event) => {
    add(50);
    let token_cookie = cookie.load("CatchIt_token");
    let token_sessionStorage = sessionStorage.getItem("CatchIt_token");
    let token = `Bearer ${
      token_cookie ? token_cookie : JSON.parse(token_sessionStorage)
    }`;

    // console.log('Req Post url Field file===> ', `${API_ENDPOINT}${url}`, data, token)
    axios
      .post(`${API_ENDPOINT}${url}`, data, {
        headers: {
          "Accept-Language": lang,
          "Content-Type": "application/json",
          Authorization: token,
        },
      })
      .then((response) => {
        // console.log("Req Post done Field file:", response.data)
        complete();
        setLoading(false);
        if (
          url === "/contactUs" ||
          url === "/contactUs/token" ||
          url === "/contactUs/withoutToken"
        ) {
          event.target.reset()
          setOpen(true);
          setErrorSnakbar(
            lang === "ar"
              ? "تم إرسال الرسالة بنجاح"
              : "Send Message Successfully"
          );
        }

        if (props.config.redirectflag) {
          setredirect(true);
        }
      })
      .catch((error) => {
        // console.log("Post Req Error Field file :", error.response)
        complete();

        if (!error.response) {
          setErrorSnakbar("Network Error");
        } else if (error.response.status === 422) {
          for (let i = 0; i < error.response.data.errors.length; i++) {
            setErrorSnakbar(error.response.data.errors[i].msg);
          }
        } else if (error.response.status === 401) {
          setErrorSnakbar(
            lang === "ar" ? "من فضلك قم بتسجيل الدخول" : "Please Login first"
          );
        } else {
          setErrorSnakbar(error.response.data.errors);
        }
        setOpen(true);
        setLoading(false);
      });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  //************************************************** */

  const SendMail = () => {
    add(50);
    // console.log('hello')

    let uri = `${API_ENDPOINT}${props.config.sendEmail}`;
    let values = getValues();
    let data = {};
    data[props.config.sendMail_Label[0]] =
      values[props.config.sendMail_Label[1]];

    // console.log('SendMail uri==> ', uri, data)
    axios
      .post(uri, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        complete();
        // console.log('SendMail done===> ', response.data)
        setConfirmMailData(values[props.config.sendMail_Label[1]]);
        setShowConfirmMail_modal(!showConfirmMail_modal);
      })
      .catch((error) => {
        complete();
        setLoading(false);
        setOpen(true);
        // console.log('SendMail error===> ', error.response.status === 403, error.response.status, error.response, error.response.data.errors)
        if (!error.response) {
          setErrorSnakbar("Network Error");
        } else if (error.response.status === 422) {
          for (let i = 0; i < error.response.data.errors.length; i++) {
            setErrorSnakbar(error.response.data.errors[i].msg);
          }
        } else if (error.response.status === 403) {
          setErrorSnakbar(error.response.data.errors);
        } else {
          setErrorSnakbar(error.response.data.errors);
        }
      });
  };

  const handleModalCancel = () => {
    setShowConfirmMail_modal(!showConfirmMail_modal);
  };
  const HandleConfirmMailDone = (str) => {
    setConfirmMailDone(str);
  };
  const confirmMailCode = () => {
    let uri = `${API_ENDPOINT}${props.config.confirmMail}`;
    let values = getValues();
    let data = {};
    data[props.config.confirmMail_label[0]] =
      values[props.config.confirmMail_label[1]];

    // console.log('confirmMailCode uri==> ', uri, data)
    axios
      .put(uri, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        complete();
        // console.log('confirmMailCode done=> ', response.data)
      })
      .catch((error) => {
        complete();
        setLoading(false);
        // console.log('confirmMailCode error=> ', error.response)
      });
  };

  //************************************************** */

  const InputhandleChange = (limit, type, e, name) => {
    var numbers = /^[0-9]+$/;
    if (limit) {
      if (type === "number") {
        // console.log("numbers ==>", e.target.value.length, limit, type, e.target.value.length <= limit)

        if (e.target.value.length <= limit && numbers.test(e.target.value)) {
          setValue(name, e.target.value);
        } else {
          let obj = getValues();
          // console.log("numbers ==> inelse", getValues(), obj[name].slice(0, -1))
          setValue(name, obj[name].slice(0, -1));
        }
      }
    } else {
      if (type === "number") {
        // console.log("numbers ==>", e.target.value)
        if (numbers.test(e.target.value)) {
          setValue(name, e.target.value);
        } else {
          let obj = getValues();
          // console.log("numbers ==> inelse", getValues(), obj[name].slice(0, -1))
          setValue(name, obj[name].slice(0, -1));
        }
      }
    }
  };

  // ************************************************** /
  const TextFieldInput = (element, register, errors, lang) => {
    return (
      <Col
        lg={element.col ? element.col : "12"}
        style={element.colStyle && element.colStyle}
      >
        <div className="textWithIcon">
          {/* {console.log("test case ===>", element.name, object[`${element.name}`])} */}
          {element.label && <label>{element.label[lang]}</label>}

          <input
            type={element.type}
            name={element.name}
            onChange={(e) =>
              InputhandleChange(
                element.limit,
                element.inputType,
                e,
                element.name
              )
            }
            ref={register}
            placeholder={element.placeholder[lang]}
            className="textStyleWithIcon px-4"
            style={element.inputStyle && element.inputStyle}
          />

          {element.isPassword && element.isPassword === true ? (
            <Link
              onClick={() =>
                element.type === "password"
                  ? (element.type = "text")
                  : (element.type = "password")
              }
              className="TextFieldIconLink"
              tyle={{
                right: lang === "en" ? "1.5rem" : "",
                left: lang === "ar" ? "1.5rem" : "",
                background: "transparent",
                border: "none",
                padding: "0px",
                outline: "none",
              }}
            >
              {element.icon && (
                <i
                  className={
                    element.type === "password"
                      ? element.icon[0]
                      : element.icon[1]
                  }
                >
                  {" "}
                </i>
              )}
            </Link>
          ) : element.confirmBtn ? (
            ConfirmMailDone === false ? (
              <Link
                onClick={SendMail}
                className="confirmSpan"
                style={{
                  right: lang === "en" ? "4%" : "",
                  left: lang === "ar" ? "4%" : "",
                }}
              >
                {element.confirmBtn}
              </Link>
            ) : (
              <span
                className="TextFieldIcon"
                style={{
                  right: lang === "en" ? "1.5rem" : "",
                  left: lang === "ar" ? "1.5rem" : "",
                  color: "#0fe00f",
                }}
              >
                <i className="fa fa-check-double"></i>
              </span>
            )
          ) : (
            <span
              className="TextFieldIcon"
              style={{
                right: lang === "en" ? "1.5rem" : "",
                left: lang === "ar" ? "1.5rem" : "",
              }}
            >
              <i className={element.icon}> </i>
            </span>
          )}
        </div>
        {/* {console.log("errors take place ==>",errors, errors[element.name], errors[element.name] ? errors[element.name]["message"] : "")} */}
        {/* {errors[element.name] && <p className="ErrorStyle" style={{ marginRight: props.config.loginFlag ? "35px" : "" }}>{errors[element.name]["message"]}</p>} */}
        {errors[element.name] && (
          <p className="ErrorStyle px-3">
            {errors[element.name]["message"][lang]}
          </p>
        )}
      </Col>
    );
  };

  //*************************************** */
  const CheckboxInput = (element, lang) => {
    let tempObj = watch();
    // let tempObj=control.getValues();
    return (
      <Col lg={element.col ? element.col : "12"}>
        <p
          style={{
            textAlign: lang === "ar" ? "right" : "left",
            color: tempObj[element.name] === true ? "orange" : "#747474",
          }}
          className="checkbox-inputStyle"
        >
          <Checkbox inputRef={register} name={element.name} />
          {element.label[lang]}
        </p>
      </Col>
    );
  };
  //*************************************** */

  const TextAreaInput = (element, register, errors, lang) => {
    return (
      <Col lg="12" className="w-100">
        <textarea
          style={element.textAreaStyle ? element.textAreaStyle : ""}
          // className="form-control"
          rows="3"
          ref={register}
          name={element.name}
          placeholder={element.placeholder[lang]}
        ></textarea>
        {errors[element.name] && (
          <p className="ErrorStyle px-3">
            {errors[element.name]["message"][lang]}
          </p>
        )}
      </Col>
    );
  };
  //*************************************** */
  const SelectWithOptions = (element, register, errors, lang) => {
    // console.log("call use effect ==>uri in element ===>", element)
    if (element.uri && !element.flag) {
      let URI = `${API_ENDPOINT}${element.uri}`;

      Req(URI, lang)
        .then((res) => {
          element.flag = true;
          let data = [],
            info = [];
          // console.log("call use effect ==>", res.data.data)
          info = res.data.data;
          for (let i = 0; i < info.length; i++) {
            let tempObj = {};
            tempObj.value = info[i].name;
            tempObj.label = info[i].name;
            tempObj.id = info[i].id;
            data.push(tempObj);
          }
          element.options = data;
          setData(element);
        })
        .catch((error) => {});
    }

    // console.log("SelectWithOptions ==>", element, element.options, element.flag, Data)
    return (
      <Col
        lg={element.col ? element.col : "12"}
        style={element.colStyle && element.colStyle}
      >
        <div>
          <Controller
            as={
              <Select
                options={
                  element.flag
                    ? element.options
                    : typeof element.options === "object"
                    ? element.options[lang]
                    : element.options
                }
              />
            }
            isMulti={element.multiOptions === true ? true : false}
            control={control}
            rules={{ required: true }}
            placeholder={
              element.placeholder ? element.placeholder[lang] : "select"
            }
            onChange={([selected]) => {
              // console.log("selected ==>", selected, element)
              // inputsField
              setValue(element.name, selected.id);
              if (element.name === "animalType") {
                setValue(inputsField[3].name, null);
                inputsField[3].uri = `/bloodType?animalType=${selected.id}`;
                inputsField[3].flag = false;
                inputsField[3].options = [];
                setInputsField(inputsField);
                setData(inputsField);
              }
              return selected;
            }}
            name={element.name}
            ref={register({ required: true })}
          />
        </div>
        <div>
          {errors[element.name] && (
            <p className="ErrorStyle px-3">
              {errors[element.name]["message"][lang]}
            </p>
          )}
        </div>
      </Col>
    );
  };

  //*************************************** */
  if (redirect) {
    // console.log('redirectState field=> ', props.config.redirectState)
    if (props.config.redirectState) {
      return (
        <Redirect
          to={{
            pathname: props.config.redirect,
            state: props.config.redirectState,
          }}
        />
      );
    } else {
      return <Redirect to={props.config.redirect} />;
    }
  }
  return (
    <div>
      <div
        style={{ width: "100%", position: "absolute", top: "0px", left: "0" }}
      >
        <LoadingBar
          progress={loadingBarProgress}
          height={3}
          color="#f49a31"
          onLoaderFinished={() => onLoaderFinished()}
        />
      </div>
      <div style={{ width: "100%", position: "absolute", bottom: "0px" }}>
        <Snackbar
          open={open}
          autoHideDuration={6000}
          onClose={handleClose}
          message={error}
        />
      </div>
      {/* {console.log("data take place", Data)} */}
      <form
        onSubmit={handleSubmit(onSubmit)}
        style={{ maxWidth: "100%", position: "relative" }}
        autocomplete="off"
      >
        <Container
          className="FieldResponsive"
          style={props.FieldsContainerStyle && props.FieldsContainerStyle}
        >
          <Row>
            {inputsField.map((element, index) => {
              return element.type === "text" ||
                element.type === "email" ||
                element.type === "password" ? (
                TextFieldInput(element, register, errors, lang)
              ) : element.type === "checkbox" ? (
                CheckboxInput(element, lang)
              ) : element.type === "textarea" ? (
                TextAreaInput(element, register, errors, lang)
              ) : element.type === "SelectWithOptions" ? (
                SelectWithOptions(element, register, errors, lang)
              ) : (
                <div className="">
                  <input
                    type={element.type}
                    name={element.name}
                    ref={register}
                    placeholder={element.placeholder[lang]}
                    className=""
                  />
                  {errors[element.name] && (
                    <p>{errors[element.name]["message"][lang]}</p>
                  )}
                </div>
              );
            })}
          </Row>
        </Container>
        <Container>
          <Row>
            <Col
              lg="12"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {props.innerSubmitBtn && props.innerSubmitBtn === true ? (
                ""
              ) : loading ? (
                <div
                  style={props.dimButton && props.dimButton}
                  className="text-center"
                >
                  <Lottie options={defaultOptions} height={50} width={50} />
                </div>
              ) : (
                <Button
                  type="submit"
                  style={props.SubmitBtnStyle && props.SubmitBtnStyle}
                >
                  {props.config && props.config.Sendbtn
                    ? props.config.Sendbtn[lang]
                    : "أضافة"}
                </Button>
              )}
            </Col>
          </Row>
        </Container>
      </form>
    </div>
  );
};
export default Field;
